
import TextButton from "@components/button/TextButton.vue";
import IconButton from "@components/button/IconButton.vue";
import TextInput from "@components/text/TextInput.vue";

import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AlinoDetectTowerTool } from "@/models/tools/draw_camera_tool";
import DetailsPanel from "../DetailsPanel.vue";

@Component({
  components: { IconButton, TextButton, TextInput, DetailsPanel },
})
export default class AlinoDetectTowerOptions extends Vue {
  //deviceConfig = require("../../../../config.json");
  @Prop() tool!: AlinoDetectTowerTool;

  setNumCameras(value: any): void {
    let v = Number.parseInt(value);
    if (v >= 4) {
        v = 4;
    }
    if (v < 1) {
        v = 1;
    }
    this.tool.numberOfDetectors = v;
    this.$emit("updated");
  }
}
